import { _ } from "i18n";
import { Button, Header, Menu, MenuItem, MenuTrigger, Popover, Section } from "react-aria-components";
// @ts-ignore
import UserPlaceholder from "ui-kit/assets/images/user-placeholder.png";
import "./accountOptions.scss";
import { ReactElement } from "react";
import { useNavigate } from "react-router";

export type AccountOptionsUserPhoto = {
	src: string;
	onError: () => void;
};

interface AccountOptionsProps {
	apiUrl?: string;
	navItems?: { id: string; label: string; link: string; icon?: ReactElement }[];
	subMenuOptions?: {
		subMenuName?: string;
		options: { label: string; id?: string; link: string; icon?: ReactElement }[];
	};
	user: { name: string; email: string; photo?: string | null };
	onLogout: () => void;
	/** When set (from parent), used for header thumbnail with load fallback */
	userPhotoImage?: AccountOptionsUserPhoto;
}

export default function AccountOptions({ apiUrl, navItems, subMenuOptions, user, onLogout, userPhotoImage }: AccountOptionsProps) {
	const navigate = useNavigate();

	const legacyThumbSrc = user.photo
		? user.photo.includes("http")
			? user.photo
			: `${apiUrl ?? ""}/${user.photo}`
		: UserPlaceholder;

	return (
		<div className="accountOptions">
			<MenuTrigger>
				<Button className="accountOptions__button header-user-thumbnail" aria-label="Account options">
					<img
						src={userPhotoImage?.src ?? legacyThumbSrc}
						alt="Profile picture Empty"
						loading="lazy"
						onError={userPhotoImage?.onError}
					/>
				</Button>
				<Popover className="accountOptions__popin active" placement="bottom end">
					<Menu
						className="accountOptions__bottom"
						onAction={(id) => {
							const option = navItems?.find((option) => option.id === id);
							const subOption = subMenuOptions?.options.find((subOption) => subOption.id === id);
							if (option) {
								navigate(option.link);
							} else if (id === "logoff") {
								onLogout();
							}
							if (subOption) {
								navigate(subOption.link, { state: { activeMenu: subOption?.id } });
							}
						}}
					>
						<Section>
							<Header className="accountMenu-header">
								<div>
									<h5>{user.name}</h5>
									<p>{user.email}</p>
								</div>
							</Header>
							{navItems?.map((option) => (
								<MenuItem className="accountMenu-option" key={`navItem-${option.id}`} id={option.id}>
									{option?.icon}
									<div>{option.label.toUpperCase()}</div>
								</MenuItem>
							))}
						</Section>

						{subMenuOptions && (
							<Section>
								<Header className="accountMenu-header">
									<div>
										<h5>{subMenuOptions.subMenuName?.toUpperCase()}</h5>
									</div>
								</Header>
								{subMenuOptions?.options.map((option) => (
									<MenuItem className="accountMenu-option" key={`subMenuItem-${option.id}`} id={option.id}>
										{option.icon}
										<div>{option.label.toUpperCase()}</div>
									</MenuItem>
								))}
							</Section>
						)}
						<MenuItem className="btn btn--white-blue-dark-border" id="logoff">
							{_("header.logout").toUpperCase()}
						</MenuItem>
					</Menu>
				</Popover>
			</MenuTrigger>
		</div>
	);
}
